module.exports = __webpack_public_path__ + "img/gfx_logo.6fbc1fe2.png";